module.exports = __webpack_public_path__ + "media/images/loader-770e0308b862995100af126e7c23dca0.svg";